import { Vue, Component } from 'vue-property-decorator';
import { TelstraUIVueDialog } from '@/external/telstra-ui-vue/components';
import { AppStoreModule } from '@/store';
import AppStore from '@/store/modules/AppStoreModule';

@Component({
  components: {
    TelstraUIVueDialog,
  },
})

export default class SelfInviteConfirmModal extends Vue {

  app$: AppStore = AppStoreModule;

  showModal(): void {
    (this.$refs.modalSelfInvite as any).show();
  }

  hideModal(): void {
    (this.$refs.modalSelfInvite as any).hide();
  }

  get selfInviteConfirmationEmail(): string {
    return this.app$.user?.email?.toLowerCase();
  }

  selfInviteConfirmed(): void {
    this.$emit('selfInvite');
  }
}
